import React from 'react';

const AddActionButton = (props) => {
  function handleClick(event) {
    event.preventDefault();
    props.onAdd();
  }

  return (
    <button
      className="button primary small add-action-button"
      onClick={event => handleClick(event)}
    >
      <i className="fa fa-plus" />
      Add {props.label}
    </button>
  );
};

export default AddActionButton;
